export const taskCenter = {
  syrw: '始于任务，终于您',
  zjlbt: '币王USDT赠金领不停',
  wdjj: '我的奖金',
  rwsm: '任务说明',
  rwlb: '任务列表',
  jljl: '奖励记录',
  klq: '可领取',
  flzm: '币王福利之门',
  dcjl: '达成即领 USDT奖励伴您一路前行',
  yjlq: '一键领取',
  lqcg: '领取成功',
  wdl: '未登录',
  jxz: '进行中',
  ylq: '已领取',
  rwjd: '任务进度',
  xsrw: '新手任务',
  hyrw: '合约任务',
  cjrz: '初级认证',
  gjrz: '高级认证',
  scbbjy: '首次币币交易',
  schyjy: '首次合约交易',
  sccz: '首次充值',
  schyhz: '首次合约划转',
  jyl: '交易量',
  ylje: '盈利金额',
  ksje: '亏损金额',
  dbkcbzj: '单笔开仓保证金',
  rjl: '入金量',
  dbczje: '单笔充值金额',
  rwxq: '任务详情'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/zh.js